module.exports = __webpack_public_path__ + "static/media/towerBack.326957ea.svg";